module.exports = __webpack_public_path__ + "static/media/Pirates-of-Islets.f1d1df25.jpg";